import React, { useState } from 'react';
import { Table, Form, Button, Modal, Pagination, Container } from 'react-bootstrap';
import './css/MainChildCategory.css';
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
const sampleData  = [
  {
    id: 1,
    motherCategory: 'Pest Control Service',
    mainCategory: 'Termite Control',
    name: 'Termite Treatment Basic',
    logo: '',
    description: 'Basic termite treatment for home or office.',
    keywords: 'termite, pest control, basic',
    seoName: 'termite-treatment-basic',
    price: 2500,
    status: 'Active'
  },
  {
    id: 2,
    motherCategory: 'Health Care Services',
    mainCategory: 'Nurse and Aya',
    name: 'Elderly Care',
    logo: '',
    description: 'Special care for elderly at home.',
    keywords: 'nurse, elderly care, home care',
    seoName: 'elderly-care',
    price: 1500,
    status: 'Active'
  },
 {
    id: 3,
    motherCategory: 'Health Care Services',
    mainCategory: 'Nurse and Aya',
    name: 'Elderly Care',
    logo: '',
    description: 'Special care for elderly at home.',
    keywords: 'nurse, elderly care, home care',
    seoName: 'elderly-care',
    price: 1500,
    status: 'Active'
  },
   {
    id: 4,
    motherCategory: 'Health Care Services',
    mainCategory: 'Nurse and Aya',
    name: 'Elderly Care',
    logo: '',
    description: 'Special care for elderly at home.',
    keywords: 'nurse, elderly care, home care',
    seoName: 'elderly-care',
    price: 1500,
    status: 'Active'
  },


   {
    id: 5,
    motherCategory: 'Health Care Services',
    mainCategory: 'Nurse and Aya',
    name: 'Elderly Care',
    logo: '',
    description: 'Special care for elderly at home.',
    keywords: 'nurse, elderly care, home care',
    seoName: 'elderly-care',
    price: 1500,
    status: 'Active'
  },


   {
    id: 6,
    motherCategory: 'Health Care Services',
    mainCategory: 'Nurse and Aya',
    name: 'Elderly Care',
    logo: '',
    description: 'Special care for elderly at home.',
    keywords: 'nurse, elderly care, home care',
    seoName: 'elderly-care',
    price: 1500,
    status: 'Active'
  },

    {
    id: 6,
    motherCategory: 'Health Care Services',
    mainCategory: 'Nurse and Aya',
    name: 'Elderly Care',
    logo: '',
    description: 'Special care for elderly at home.',
    keywords: 'nurse, elderly care, home care',
    seoName: 'elderly-care',
    price: 1500,
    status: 'Active'
  },

    {
    id: 7,
    motherCategory: 'Health Care Services',
    mainCategory: 'Nurse and Aya',
    name: 'Elderly Care',
    logo: '',
    description: 'Special care for elderly at home.',
    keywords: 'nurse, elderly care, home care',
    seoName: 'elderly-care',
    price: 1500,
    status: 'Active'
  },

    {
    id: 8,
    motherCategory: 'Health Care Services',
    mainCategory: 'Nurse and Aya',
    name: 'Elderly Care',
    logo: '',
    description: 'Special care for elderly at home.',
    keywords: 'nurse, elderly care, home care',
    seoName: 'elderly-care',
    price: 1500,
    status: 'Active'
  },
    {
    id: 9,
    motherCategory: 'Health Care Services',
    mainCategory: 'Nurse and Aya',
    name: 'Elderly Care',
    logo: '',
    description: 'Special care for elderly at home.',
    keywords: 'nurse, elderly care, home care',
    seoName: 'elderly-care',
    price: 1500,
    status: 'Active'
  },
  {
    id: 10,
    motherCategory: 'Health Care Services',
    mainCategory: 'Nurse and Aya',
    name: 'Elderly Care',
    logo: '',
    description: 'Special care for elderly at home.',
    keywords: 'nurse, elderly care, home care',
    seoName: 'elderly-care',
    price: 1500,
    status: 'Active'
  },


  
  // Add more child categories here
];

const ITEMS_PER_PAGE = 10;
export default function MainChildCategory() {
  const [categories, setCategories] = useState(sampleData);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const [categoryData, setCategoryData] = useState({
    motherCategory: '',
    mainCategory: '',
    name: '',
    logo: null,
    description: '',
    keywords: '',
    seoName: '',
    price: ''
  });

  const filtered = categories.filter(cat =>
    cat.motherCategory.toLowerCase().includes(search.toLowerCase()) ||
    cat.mainCategory.toLowerCase().includes(search.toLowerCase()) ||
    cat.name.toLowerCase().includes(search.toLowerCase()) ||
    cat.seoName.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentCategories = filtered.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const handleShow = () => {
    setEditingId(null);
    setCategoryData({
      motherCategory: '',
      mainCategory: '',
      name: '',
      logo: null,
      description: '',
      keywords: '',
      seoName: '',
      price: ''
    });
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'logo') setCategoryData({ ...categoryData, logo: files[0] });
    else setCategoryData({ ...categoryData, [name]: value });
  };

  const handleAddOrEdit = () => {
    if (!categoryData.name || !categoryData.motherCategory || !categoryData.mainCategory || !categoryData.price) {
      alert('Please fill all required fields');
      return;
    }

    if (editingId) {
      // Update existing category
      setCategories(categories.map(cat =>
        cat.id === editingId ? { ...cat, ...categoryData } : cat
      ));
    } else {
      // Add new category
      setCategories([
        ...categories,
        { ...categoryData, id: categories.length + 1, status: 'Active' }
      ]);
    }

    handleClose();
  };

  const handleEdit = (id) => {
    const cat = categories.find(c => c.id === id);
    if (cat) {
      setEditingId(id);
      setCategoryData({ ...cat, logo: null }); // don’t pre-fill file input
      setShowModal(true);
    }
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure to delete?')) {
      setCategories(categories.filter(cat => cat.id !== id));
    }
  };

  return (
    <Container fluid>
      <h2>Manage Child Category</h2>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Form.Control
          type="text"
          placeholder="Search..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: '300px' }}
        />
        <Button variant="primary" onClick={handleShow}>Add Child Category</Button>
      </div>

      <div className="table-container" style={{fontSize:"14px"}}>
        <Table bordered hover responsive>
          <thead className="custom-thead">
            <tr>
              <th>SL NO.</th>
              <th>Mother Category</th>
              <th>Main Category</th>
              <th>Child Category Name</th>
              <th>Logo</th>
              <th>Description</th>
              <th>Keywords</th>
              <th>SEO Name</th>
              <th>Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentCategories.length ? (
              currentCategories.map((cat, idx) => (
                <tr key={cat.id} className={idx % 2 === 0 ? 'even-row' : 'odd-row'}>
                  <td>{startIndex + idx + 1}</td>
                  <td>{cat.motherCategory}</td>
                  <td>{cat.mainCategory}</td>
                  <td>{cat.name}</td>
                  <td>{cat.logo ? cat.logo.name : 'No Logo'}</td>
                  <td>{cat.description}</td>
                  <td>{cat.keywords}</td>
                  <td>{cat.seoName}</td>
                  <td>{cat.price}</td>
                  <td>
                    <Button variant="outline-primary" size="sm" className="me-2" onClick={() => handleEdit(cat.id)}><FiEdit/></Button>
                    <Button variant="outline-danger" size="sm" onClick={() => handleDelete(cat.id)}><RiDeleteBin6Line/></Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center">No categories found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <Pagination className="justify-content-center mt-3">
        <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1}/>
        <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}/>
        {[...Array(totalPages)].map((_, idx) => (
          <Pagination.Item key={idx + 1} active={currentPage === idx + 1} onClick={() => setCurrentPage(idx + 1)}>
            {idx + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}/>
        <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}/>
      </Pagination>

      {/* Add / Edit Modal */}
      <Modal show={showModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{editingId ? 'Edit Child Category' : 'Add Child Category'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Mother Category</Form.Label>
              <Form.Control type="text" name="motherCategory" placeholder="Enter Mother Category" value={categoryData.motherCategory} onChange={handleChange}/>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Main Category</Form.Label>
              <Form.Control type="text" name="mainCategory" placeholder="Enter Main Category" value={categoryData.mainCategory} onChange={handleChange}/>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Child Category Name</Form.Label>
              <Form.Control type="text" name="name" placeholder="Enter Child Category Name" value={categoryData.name} onChange={handleChange}/>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Logo</Form.Label>
              <Form.Control type="file" name="logo" onChange={handleChange}/>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={3} name="description" value={categoryData.description} onChange={handleChange}/>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Keywords</Form.Label>
              <Form.Control type="text" name="keywords" value={categoryData.keywords} onChange={handleChange}/>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>SEO Name</Form.Label>
              <Form.Control type="text" name="seoName" value={categoryData.seoName} onChange={handleChange}/>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Price</Form.Label>
              <Form.Control type="number" name="price" placeholder="Enter Price" value={categoryData.price} onChange={handleChange}/>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" onClick={handleAddOrEdit}>
            {editingId ? 'Update Category' : 'Add Category'}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
      );
}